import React from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel, FormControlLabelProps } from '@material-ui/core';

interface Props extends Omit<FormControlLabelProps, "control"> {
  color: "default" | "primary" | "secondary"
}

const Checkbox: React.FC<Props> = props => {
  return (
    <FormControlLabel
      {...props}
      control={
        <MuiCheckbox color={props.color} />
      }
    />
  )
}

export default Checkbox;
